import { request } from './client.js';
/**
 * registerPushSubscription — POST /operator/push/subscribe
 *
 * Registers (or upserts) a Web Push subscription for the authenticated
 * operator/supervisor. Re-subscribing with the same endpoint updates keys
 * and userId in place.
 *
 * Guard: JwtAuthGuard + operator or supervisor role.
 */
export async function registerPushSubscription(dto) {
    return request('/operator/push/subscribe', {
        method: 'POST',
        body: dto,
    });
}
//# sourceMappingURL=push.js.map